var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){$event.preventDefault();return _vm.nextStep()}}},[_c('h3',[_vm._v(_vm._s(_vm.next_step))]),_c('img',{attrs:{"src":require("@/assets/arrow_forward_black.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }